export const phoneWidth = 768;
export const links = {
  kakao: 'https://pf.kakao.com/_dxdPbb/chat',
  insta: 'https://www.instagram.com/golden_meju',
  survey: 'https://forms.gle/GWTCYi71LWYYR5jn6',
};
